import { blastApi } from "../../blastApi";
import { Prediction, PredictionRequest, PredictionSchema } from "../schemas";

export const postBountySimulatorPrediction = async (
  tournamentId: string,
  predictionRequest: PredictionRequest,
): Promise<Prediction | null> => {
  const { data } = await blastApi.post<unknown>(`v1/bounty-simulator/predictions/${tournamentId}`, predictionRequest);

  if (!data) {
    return null;
  }

  return PredictionSchema.parse(data);
};
